
import GLazyAsset from '../g-lazy-asset';

export default {
  name: 'g-social-share',
  components: {
    GLazyAsset,
  },
  props: {
    url: {
      type: String,
      required: true,
    },
  },
};
